export const KEYWORD_BASED = 'keyword_base';
export const PHRASE_BASED = 'phrase_base';
